import { cadCurrencyFormat } from "../pricing-reports/constants";
import { mapPriceHistoryBreakdownRowsToDisplayItems } from "../pricing-reports/priceHistoryBreakdownDisplay";
import {
  FLYER_DISCOUNT_BUCKET_LABELS,
  mapRowToFlyerDiscountBucket,
} from "./flyerReportChartUtils";

function toNumberOrNull(value) {
  if (typeof value === "number" && Number.isFinite(value)) return value;
  if (typeof value === "string" && value.trim() !== "" && !Number.isNaN(Number(value))) {
    const parsed = Number(value);
    return Number.isFinite(parsed) ? parsed : null;
  }
  return null;
}

function formatOriginalPriceDisplay(row) {
  const originalPrice = toNumberOrNull(row?.original_price);
  return originalPrice != null ? cadCurrencyFormat.format(originalPrice) : "—";
}

function formatSaleTypeDisplay(row) {
  const bucket = mapRowToFlyerDiscountBucket(row);
  return FLYER_DISCOUNT_BUCKET_LABELS[bucket] || "—";
}

function formatSaleAmountDisplay(row) {
  const bucket = mapRowToFlyerDiscountBucket(row);
  const saleAmount = toNumberOrNull(row?.sale_amount);
  if (saleAmount == null) return "—";
  if (bucket === "percentOff") return `${saleAmount}%`;
  if (bucket === "dollarOff") return cadCurrencyFormat.format(saleAmount);
  return "—";
}

/**
 * @param {any[]} rows Normalized gallery rows from `fetchFlyerGalleryPage`.
 */
export function mapFlyerGalleryRowsToDisplayItems(rows) {
  const baseItems = mapPriceHistoryBreakdownRowsToDisplayItems(rows);
  return baseItems.map((item, index) => {
    const row = rows?.[index];
    return {
      ...item,
      originalPrice: formatOriginalPriceDisplay(row),
      saleType: formatSaleTypeDisplay(row),
      saleAmount: formatSaleAmountDisplay(row),
    };
  });
}

/**
 * @param {{ product?: string, productName?: string } | null | undefined} displayItem
 */
export function formatFlyerGalleryDialogTitle(displayItem) {
  const productName = String(displayItem?.product ?? displayItem?.productName ?? "").trim();
  return `${productName || "Product"} Gallery`;
}
